import _ from 'lodash';
import { apiSearch, apiFetch } from '../utility';

const apiBase = 'assignedLoadingNumber';

export const search = ({ params = {}, callback = _.noop } = {}) => {
	return (dispatch) => {
		apiSearch({
			base: apiBase,
			params,
			dispatch,
			callback,
		});
	};
};

export const get = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};

export const save = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.save`,
			params,
			dispatch,
			callback,
		});
	};
};

export const remove = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.remove`,
			params,
			dispatch,
			callback,
		});
	};
};

export const lookup = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.lookup`,
			params,
			dispatch,
			skipErrors: true,
			callback,
		});
	};
};

export const importCsv = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.import`,
			params,
			dispatch,
			callback,
		});
	};
};
